export const REQUEST_CAROUSEL_DATA = 'REQUEST_CAROUSEL_DATA';
export const RECEIVE_CAROUSEL_DATA = 'RECEIVE_CAROUSEL_DATA';

export const receiveCarouselData = (payload) => ({
  type: RECEIVE_CAROUSEL_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/carouseActions.js